import React from "react";
import { testimonials } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function Testimonials() {
  const ref = useReveal();

  return (
    <section className="section" id="testimonials" ref={ref}>
      <div className="section-head" data-reveal>
        <h2 className="section-title">
          Отзиви<span className="annotation">(доверието)</span>
        </h2>
        <span className="section-num">04.</span>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((t) => (
          <article className="testimonial-card" key={t.id} data-reveal>
            <p className="quote">„{t.quote}“</p>
            <div className="who">
              <span className="author">{t.author}</span>
              <span className="context">{t.context}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
